module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABHNCSVQICAgIfAhkiAAAATdJREFUKJGN0L8vw1EUBfBz3/u2ZVImiU1YVIK2kRAGicTYGIRIf4hETBb/is1UoYMYTCZJYxKJtB2EyWgVPyKq1XePoUpDybvbOXmf+16eMJEIuRFZATCtVvfC+fIFPMa4mFmGwQwMjHEmV8skR70gocnvBBMAKS8I4rW9cMCjFxThZStQeR+64a4XtNXaKYD3z/yGUqnhd+PR9QtUiwAgRgZcJr7oBQHARp9PSDw1G7PA7OSUF5Sd25o6lxcVBwCOmmU6PvsflPbAXDzhaDYgzd6qHsp+ucilWLjR3bUNmKg6LUQKpSv5uamenhizEmzS0AIAyTsjCAjpbzt29gsCAFfHhzWw6xTp6/hMSrUjBABuDUXcQ28KwjmY5l+0RpWVP+HXgrVYf10j8wFlUAU9onpuDyrHH2aec8BLKEoiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/small_phone.png
// module id = BlgS
// module chunks = 51